<div>
    <tree :nodes="scenariosTree" v-model="changeCategory" :filter="filter">
        <template v-slot:label="row">
            <slot name="line" :data="row.data">
                {{row.data.name}}
            </slot>
        </template>
    </tree>
</div>
